module.exports = __webpack_public_path__ + "img/ios5icon1.c5213219.png";